/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'skip-next': {
    width: 24,
    height: 24,
    viewBox: '0 96 960 960',
    data: '<path pid="0" d="M660 816V336h80v480h-80zm-440 0V336l360 240-360 240z"/>'
  }
})
